import { LanguageCode, OnlinePaymentMethod } from '@interticket/core';

export const PAYMENT_URLS = {
  [OnlinePaymentMethod.OTP_SIMPLE]: {
    [LanguageCode.HU]: 'http://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf',
    [LanguageCode.EN]: 'http://simplepartner.hu/PaymentService/Payment_information.pdf',
  },
  [OnlinePaymentMethod.CIB]: {
    [LanguageCode.HU]: 'https://www.jegy.hu/articles/513/cib-fizetesi-tajekoztato',
    [LanguageCode.EN]: 'https://www.jegy.hu/articles/513/cib-fizetesi-tajekoztato?lang=en',
  },
};
